<template>
  <date-range-picker
    ref="picker"
    :startDate="startDate"
    opens="right"
    :ranges="ranges"
    :locale-data="date_locale"
    v-model="dateRange"
  >
  </date-range-picker>
</template>

<script>

import {en, ru} from 'vuejs-datepicker/dist/locale'
import DateRangePicker from 'vue2-daterange-picker'
import moment from "moment";

export default {
  components: {
    DateRangePicker
  },
  data() {
    return {
      ru: ru,
      startDate: '',
      dateRange: {
        startDate: moment().startOf('isoWeek').format(),
        endDate: moment().endOf('isoWeek').format(),
      },
      ranges: { //default value for ranges object (if you set this to false ranges will no be rendered)
        'Текущая неделя': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
        'Прошлая неделя': [moment().subtract(1, 'isoWeek').startOf('isoWeek'), moment().subtract(1, 'isoWeek').endOf('isoWeek')],
        'Текущий месяц': [moment().startOf('month'), moment().endOf('month')],
        'Прошлый месяц': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      date_locale: {
        firstDay: 1,
        format: 'DD.MM.YYYY',
        applyLabel: 'Выбрать',
        cancelLabel: 'Отмена',
      },
    }
  },
  methods: {
    getRange() {
      return [
        moment(this.dateRange.startDate).format('YYYY-MM-DD'),
        moment(this.dateRange.endDate).format('YYYY-MM-DD'),
      ]
    }
  }
}
</script>
